import {ScanRepository} from '../repositories/ScanRepository';
import {Service} from '../entities/Service';

export class GetAvailableServicesUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(): Promise<Service[]> {
    return await this.scanRepository.getAvailableServices();
  }
}

